import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IFacility } from "../../utils/types/models";

export default createEntityReducer<IFacility>(Endpoint.Facilities, Endpoint.FacilitiesList);
